module.exports = __webpack_public_path__ + "img/water.50e657e2.svg";